export default "__VITE_ASSET__B1XlryBj__"